import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Disable StrictMode to prevent DOM manipulation issues
root.render(<App />);
